import { useAuth } from '@/common/hooks/useAuth'
import { colors } from '@/core/styles/tokens'

interface LoginFormProps {
  error?: string | null
}

export function LoginForm({ error }: LoginFormProps) {
  const { loginWithSSO } = useAuth()

  return (
    <div style={styles.card}>
      <h2 style={styles.title}>Sign in</h2>

      {error && <div style={styles.error}>{error}</div>}

      <button type="button" onClick={loginWithSSO} style={styles.button}>
        Sign in with SSO
      </button>
    </div>
  )
}

const styles: Record<string, React.CSSProperties> = {
  card: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    padding: '2rem',
    maxWidth: '400px',
    margin: '0 auto',
    backgroundColor: colors.white,
    borderRadius: '8px',
    boxShadow: '0 2px 10px rgba(49,50,76,0.10)',
  },
  title: {
    margin: 0,
    color: colors.martinique,
  },
  button: {
    padding: '0.75rem',
    fontSize: '1rem',
    fontWeight: 600,
    color: colors.white,
    backgroundColor: colors.sea,
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    marginTop: '0.5rem',
  },
  error: {
    padding: '0.75rem',
    backgroundColor: colors.errorBackground,
    color: colors.error,
    borderRadius: '8px',
    fontSize: '0.875rem',
  },
}
